<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="quartzJobs" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="quartzJobId" selectionMode="single"
  [(selection)]="quartzJob" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="100"
  [rowsPerPageOptions]="[100]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Quartz Jobs</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New QuartzJob +</button>
        }
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New QuartzJob +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <!-- <p-sortIcon [field]="col.field"></p-sortIcon> -->
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <!-- <tr *ngIf="showFilter">
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quartzJobId', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'state', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'nextFireTime', 'in')"></th>

    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr> -->
</ng-template>
<ng-template pTemplate="body" let-quartzJob>
  <tr [pSelectableRow]="quartzJob">
    <td>{{quartzJob.quartzJobId}} </td>
    <td>{{quartzJob.name}}</td>
    <td>{{quartzJob.state}}</td>
    <td>{{fixDateTime(quartzJob?.prevFireTime)}}</td>
    <td>{{fixDateTime(quartzJob?.nextFireTime)}}</td>
    <td><span style="float:none">
      @if (showFilter) {
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="triggerNow(quartzJob)">Trigger Now</button>
      }

      @if (showFilter) {
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="resetTriggerState(quartzJob)">Reset State</button>
      }
    </span>


  </td>
</tr>
</ng-template>
</p-table>